module.exports = __webpack_public_path__ + "static/img/linda_hands.30caffe.png";